export const INSURER_MAX_AGE = 65;
export const INSURER_MIN_AGE = 18;

export const COVER_MIN_AGE = 1;

export const COVER_MAX_AGE = 70;
